<template>
  <div class="cmp-contacts-files-files_list dt-page">
    <div class="dt-page--top-bar v1">
      <div class="dt-page--add-button">
        <div class="dt-icon-container">
          <img
            @click="onAddContactFileClick"
            class="dt-icon v5 s1"
            src="static/buttons/add.svg"
            alt
          />
        </div>
      </div>
      <div class="search">
        <InputField
          :value="searchString"
          :placeholder="'Search'"
          :config="{
            borderStyle: 'bottom',
            maxWidth: '200px',
            minWidth: '200px',
            width: '200px',
          }"
          @keyup="onSearchInputKeyup"
        ></InputField>
      </div>
      <div class="right-space"></div>
    </div>
    <v-layout row wrap>
      <v-flex md12 pa-1>
        <div class="contact-list dt-page--data-table">
          <NTable
            id="contacts-files-files_list"
            class="h2 c2 p0"
            :config="tableConfig"
            :headers="contactHeaders"
            :items="list"
            :loadingFlag="loadingFlag"
            @scrollnext="onContactFilesNext"
          >
            <template v-slot:thead="{ thcon, thtext }">
              <tr>
                <th
                  v-for="header in contactHeaders"
                  v-bind="thcon(header.value)"
                  :key="header.value"
                >
                  <div
                    v-if="header.value == 'booking_default'"
                    class="header-name"
                  >
                    <div class="ut-flex">
                      {{ thtext(header.value) }}
                      <div
                        class="dt-icon-container"
                        style="min-width: 30px; max-width: 30px"
                        :title="'Every booking will automatically contain those files'"
                      >
                        <img
                          src="static/icons/Help2Red.svg"
                          class="dt-icon v5 s2"
                        />
                      </div>
                    </div>
                  </div>
                  <div v-else class="header-name">
                    {{ $dft.capHead(thtext(header.value)) }}
                  </div>
                </th>
              </tr>
            </template>
            <template v-slot:item="{ item, tdcon }">
              <tr>
                <td v-bind="tdcon('documents')">
                  <span>
                    <a
                      style="font-weight: bold; color: var(--text-primary)"
                      target="_blank"
                      :href="item['shorten_link_url']"
                      >{{ item["file_name"] }}</a
                    >
                  </span>
                </td>
                <td v-bind="tdcon('description')">
                  <div class="ut-flex">
                    <!-- <TextField
                      class="m1"
                      :id="'relation'"
                      v-bind="textFieldConfig"
                      :value="item['file_description']"
                      :placeholder="'Company'"
                      v-on:blur="(e) => onFileDescriptionTextBoxBlur(e, item)"
                    ></TextField> -->
                    <input
                      style="width: 100%"
                      type="text"
                      class="ntable--textfield"
                      name="relation"
                      id="relation"
                      :value="item['file_description']"
                      v-on:blur="(e) => onFileDescriptionTextBoxBlur(e, item)"
                    />
                  </div>
                </td>
                <td v-bind="tdcon('booking_default')">
                  <div class="ut-rowcen">
                    <div class="dt-checkbox v2 s1">
                      <input
                        type="checkbox"
                        @click="(e) => onBookingDefaultsCBChange(e, item)"
                        :name="item.file_id"
                        :id="item.file_id"
                        :checked="item['for_all_calendar_dates'] == '1'"
                      />
                      <div class="checkmark"></div>
                    </div>
                  </div>
                </td>
                <td v-bind="tdcon('user')">
                  <span>{{ item["user_name"] }}</span>
                </td>
                <td v-bind="tdcon('date')">
                  <span>{{ item.created.substr(0, 11) }}</span>
                </td>
                <td v-bind="tdcon('lock')">
                  <div
                    class="dt-icon-container"
                    :title="'Private files are only for Details users'"
                    v-if="item['public'] != '1'"
                  >
                    <img
                      src="static/icons/booking/lock-closed.svg"
                      class="dt-icon v5 s2"
                    />
                  </div>
                </td>
                <td v-bind="tdcon('del')">
                  <img
                    src="static/icons/delete.svg"
                    @click.stop="(e) => deleteContactFile(item)"
                    class="dt-icon v5 s2"
                    alt
                  />
                </td>
              </tr>
            </template>
          </NTable>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { ContactStoreNamespace as storeNS } from "../store";
import { mapGetters, mapActions } from "vuex";
import * as ActionTypes from "../store/types";
import { SelectResults } from "../../booking/router/router";
import NTable from "@/plugins/datatable/datatable";
import { Subject } from "rxjs";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";
import InputField from "@plugins/text-field/input-field";

import { ConfirmationService } from "@/dt-plugins/confirmation/confirmation.service";
import { ContactFilesService } from "../services/contact_files.service";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../plugins/datatable";

export default {
  components: {
    NTable,
    InputField,
  },
  mounted: function () {
    this.fetchListReset();

    this.$subscribeTo(
      this.subjectSearchSubject$
        .asObservable()
        .pipe(distinctUntilChanged(), debounceTime(500)),
      (searchString) => {
        if (searchString.length > 0) {
          this.searchContactFiles(searchString);
        } else {
          this.fetchListReset();
        }
      }
    );
  },
  data: function () {
    return {
      startRow: 0,
      subjectSearchSubject$: new Subject(),
      searchString: "",
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        immediateValidation: false,
      },
      loadingFlag: false,
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler: function (to, from) {},
    },
  },
  computed: {
    ...mapGetters(storeNS, {
      contactFiles: "contactFiles",
      contactFilesSearchResult: "contactFilesSearchResult",
      contactFilesStart: "contactFilesStart",
    }),
    tableConfig: function () {
      return createNTableConfig({
        fullHeight: true,
        rowHeight: 40,
      });
    },
    list: function () {
      return this.searchString.length
        ? this.contactFilesSearchResult
        : this.contactFiles;
    },
    contactHeaders: function () {
      return [
        createTableHeader("documents", { fw: 700, f: 1.2 }),
        createTableHeader("description", { f: 1.4 }),
        createTableHeader("booking_default", {
          ta: "center",
          mw: 150,
        }),
        createTableHeader("user", { text: this.$t("user"), mw: 150 }),
        createTableHeader("date", { mw: 150, f: 0.6 }),
        createTableHeader("lock", { text: false, mw: 30 }),
        createTableHeader("del", { text: false, mw: 35 }),
      ];
    },
  },
  methods: {
    ...mapActions(storeNS, {
      [ActionTypes.ContactFiles.FETCH.ALL]: ActionTypes.ContactFiles.FETCH.ALL,
      [ActionTypes.ContactFilesSearchResult.FETCH.ALL]:
        ActionTypes.ContactFilesSearchResult.FETCH.ALL,
      [ActionTypes.ContactFiles.DELETE.SINGLE]:
        ActionTypes.ContactFiles.DELETE.SINGLE,
    }),
    onFileDescriptionTextBoxBlur: function (e, item) {
      ContactFilesService.modifyContactFileRow(
        item.file_id,
        "file_description",
        e.target.value
      );
    },
    onBookingDefaultsCBChange: function (e, item) {
      let value = e.target.checked ? "1" : "0";
      ContactFilesService.modifyContactFileRow(
        item.file_id,
        "for_all_calendar_dates",
        value
      );
    },

    deleteContactFile: function (item) {
      ConfirmationService.create({
        subject: this.$t("delete_file_msg"),
        model: true,
        width: 500,
        completed: (res) => {
          switch (res) {
            case "OK": {
              this[ActionTypes.ContactFiles.DELETE.SINGLE](item);
              break;
            }
            default: {
            }
          }
        },
      });
    },
    onContactFilesNext: function (scrollPercent) {
      if (this.searchString.length == 0) {
        this.fetchListNext();
      }
    },
    fetchListNext: function () {
      this.fetchContactFilesNext();
    },
    fetchListReset: async function () {
      this.loadingFlag = true;
      await this[ActionTypes.ContactFiles.FETCH.ALL]();
      this.loadingFlag = false;
    },
    searchContactFiles: function (key) {
      this[ActionTypes.ContactFilesSearchResult.FETCH.ALL](key);
    },
    fetchContactFilesNext: function () {
      console.log("ROW", this.contactFilesStart, this.startRow);
      if (this.contactFilesStart == this.startRow) {
        this.startRow += 100;

        this[ActionTypes.ContactFiles.FETCH.ALL](this.startRow);
      }
    },
    onSearchInputKeyup: function (event) {
      this.searchString = event.target.value;
      this.subjectSearchSubject$.next(this.searchString);
    },
    onAddContactFileClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "file_uploader",
          external_id: "",
          external_table: "contacts",
        },
      });
    },
  },
};
</script>

<style lang="scss">
.cmp-contacts-files-files_list {
  td.file_name a {
  }
  .dt-page--data-table {
    --offset: 135px;
  }
  .dt-page--top-bar {
    .input-field-container {
      max-width: 128px;
    }
  }
}
</style>
